import {
  GraphQLEnv,
  brand,
  env,
  getConfigValue,
  graphqlEnv,
  graphqlGatewayEnv,
} from 'utils/environment';

export enum QUERY_TYPE {
  LambdaGraphqlQuery,
  SanityGroqQuery,
  SanityGraphqlQuery,
  GatewayGraphqlQuery,
}

export const getGraphqlGatewayApiUrl = () => {
  const awsConfig = getConfigValue({ key: 'aws', defaultValue: {} });
  switch (graphqlGatewayEnv()) {
    case GraphQLEnv.TEST:
      return 'https://use1-dev-bk-gateway.rbictg.com/graphql';
    case GraphQLEnv.LOCAL:
      return 'http://localhost:3002/graphql';
    default:
      return (
        awsConfig.gqlGatewayApiUrl ||
        `https://use1-${graphqlEnv()}-${brand()}-gateway.rbictg.com/graphql`
      );
  }
};

export const MENU_API_URL = `https://use1-${env()}-bk-menu.rbictg.com/store`;

export enum HttpErrorCodes {
  BadRequest = 400,
  InternalServerError = 500,
  TooManyRequests = 429,
  Unauthorized = 401,
  Conflict = 409,
}
